import type { MasterControlIngestionPipeline } from "@/hooks/useMasterControl";

type MCIngestionCardProps = {
  pipeline: MasterControlIngestionPipeline;
  onSelect: (pipeline: MasterControlIngestionPipeline) => void;
};

const STATUS_STYLES: Record<string, string> = {
  ok: "bg-emerald-500/80",
  warning: "bg-amber-500/80",
  error: "bg-rose-500/80",
};

export function MCIngestionCard({ pipeline, onSelect }: MCIngestionCardProps) {
  const statusClass = STATUS_STYLES[pipeline.status] ?? STATUS_STYLES.ok;
  return (
    <button
      type="button"
      onClick={() => onSelect(pipeline)}
      className="flex w-full items-start gap-4 rounded-2xl border border-border bg-background/60 p-4 text-left shadow-sm transition hover:shadow-lg"
    >
      <span className={`mt-1 h-12 w-1 rounded-full ${statusClass}`} aria-hidden />
      <div className="flex-1 space-y-1">
        <div className="flex items-center justify-between">
          <p className="text-base font-semibold text-foreground">{pipeline.label}</p>
          <span className="text-xs uppercase tracking-wide text-muted-foreground">{pipeline.status}</span>
        </div>
        <div className="grid gap-2 text-sm text-foreground/70 md:grid-cols-2">
          <div>
            <p className="text-xs uppercase tracking-wide text-muted-foreground">Pending</p>
            <p className="text-lg font-semibold text-foreground">{pipeline.pending}</p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-wide text-muted-foreground">Last run</p>
            <p>{pipeline.last_run ? new Date(pipeline.last_run).toLocaleString() : "Never"}</p>
          </div>
        </div>
        {pipeline.last_error && (
          <p className="text-xs text-rose-300">
            Last error: <span className="font-mono">{pipeline.last_error}</span>
          </p>
        )}
      </div>
    </button>
  );
}

export default MCIngestionCard;
